import { storeCreator } from '@/utils/store/store.utils';

export interface CategorySpendLimit {
  category_type: string;
  category_spend_limit: string;
}

interface State {
  spendLimits: CategorySpendLimit[];
  sourceSpendLimits: CategorySpendLimit[];
  draftSpendLimits: CategorySpendLimit[];

  handleSetSpendLimits: (value: CategorySpendLimit[]) => void;
  handleSetSourceSpendLimits: (value: CategorySpendLimit[]) => void;
  handleUpdateDraftSpendLimit: (categoryType: string, value: string) => void;
  handleInitDraft: () => void;
  handleApplyDraft: () => void;
  handleDiscardDraft: () => void;
  handleReset: () => void;
}

export const useCategorySpendLimitsStore = storeCreator<State>((set) => ({
  spendLimits: [],
  sourceSpendLimits: [],
  draftSpendLimits: [],

  handleSetSpendLimits: (value) => set((state) => ({ ...state, spendLimits: value })),
  handleSetSourceSpendLimits: (value) => set((state) => ({ ...state, sourceSpendLimits: value })),
  handleUpdateDraftSpendLimit: (categoryType, value) =>
    set((state) => ({
      ...state,
      draftSpendLimits: state.draftSpendLimits.map((item) =>
        item.category_type === categoryType
          ? { ...item, category_spend_limit: value }
          : item
      ),
    })),
  handleInitDraft: () => set((state) => ({ ...state, draftSpendLimits: [...state.spendLimits] })),
  handleApplyDraft: () =>
    set((state) => ({
      ...state,
      spendLimits: state.draftSpendLimits,
      sourceSpendLimits: state.draftSpendLimits,
    })),
  handleDiscardDraft: () => set((state) => ({ ...state, draftSpendLimits: [] })),
  handleReset: () => set((state) => ({
    ...state,
    spendLimits: state.sourceSpendLimits,
  })),
}));
